import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06055083"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06055083')) {
      api.createRecord('06055083', component.options)
    } else {
      api.reload('06055083', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=06055083", function () {
      api.rerender('06055083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SearchQuery/index.vue"
export default component.exports